import { connect } from 'react-redux';

import {requestTickets,requestContact,addTicket,requestTicket} from '../modules/support';

import TicketDetailView from '../components/TicketDetailView';

const mapDispatchToProps = {
  requestTickets,
  requestContact,
  addTicket,
  requestTickets
};

const mapStateToProps = (state, ownProps) => ({
  tickets: state.support.tickets,
  id: ownProps.params.id
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketDetailView);



// WEBPACK FOOTER //
// src/routes/support/containers/TicketContainer.js